/* eslint no-unused-vars: 0 */
/* eslint prefer-const: 0 */

import React        from 'react';
import PropTypes    from 'prop-types';
import { Link }     from 'react-router-dom';
import { cuisineTypes } from './common/cuisineTypes';
import dateFormat   from 'dateFormat';
import styles       from '../styles/lists.styl';
import moment       from 'moment';

const symbolFromType = (cuisine) => {
  const type = cuisineTypes.find((c) => {
    return c.type === cuisine.toLowerCase();
  });
  return type.symbol;
};

const getDisplayName = (review) => {
  return review.first + ' ' + review.last.charAt(0) + '.';
};

const fromNow = (date) => {
  return moment(date).fromNow();
};

const constructReviewText = (item) => {
  let text = item.review;
  let num  = item.rating;

  if(num === 'bless') {
    num = '[👑]';
  } else if (num > 0) {
    num = '[+' + num + ']';
  } else {
    num = '[' + num + ']';
  }

  if (text.length > 1) {
    text = ' ' + num + ' - "' + item.review + '"';
  } else {
    text = ' ' + num;
  }

  return text;
};

class List extends React.Component {
  render() {
    const items = this.props.items.filter((item, index) => {
      return (item.rating === 'bless');
    });
    const listItems = items.map((item, index) => {
      return (
        <li key={index} className="visit-item">
          <div className="meat">
            <span>
              <span className="cuisine">{ symbolFromType(item.cuisine) }</span>
              <span> </span>
              <span className="name">{ item.name }</span>
              <span> - </span>
              <span className="review">{ '"' + item.review + '"' }</span>
            </span>
            <div className="bottom">
              <span className="neighborhood">{ item.area }, </span>
              <span className="location">{ item.city }</span>
              <span> - </span>
              <span className="date">{ fromNow(item.date) }</span>
            </div>
          </div>
        </li>
      );
    });
    return (
      <div>
        <ul className="list-group">
          { listItems }
        </ul>
      </div>
    );
  }
}


List.propTypes = {
  items: PropTypes.array.isRequired,
  remove: PropTypes.func
};

export default List;



// WEBPACK FOOTER //
// ./client/components/BlessingsList.js